interface NetworkInfo {
  status: number
  message: string
  title: string
}

/**
 * Parses an error object (typically from an Axios response) to extract
 * meaningful network error information including status code, message, and title.
 *
 * @param {any} err - The error object to parse. This could be a raw error,
 *                    an AxiosError, or a server error response.
 * @returns {NetworkInfo} A normalized object containing status, message, and title.
 */
export const getNetworkInfo = (err: any): NetworkInfo => {
  const { response } = err
  const data = response?.data?.data || err?.response?.data
  const errors = data?.response?.errors || data?.errors || response?.errors

  const netInfo = {
    status: parseInt(data?.status || data?.code || response?.status || err?.status || 500),
    title: data?.title || response?.title || err.title || 'Network Error',
    message:
      data?.message ||
      data?.detail ||
      response?.message ||
      response?.detail ||
      err?.message ||
      'Something went wrong. Please try again.',
  }

  // Case Axios error with structured errors in array
  if (errors && Array.isArray(errors)) {
    errors.forEach((error) => {
      netInfo.status = parseInt(error.status || error.code)
      netInfo.message = error.message || error.detail || err.message
      netInfo.title = error.title
    })
  }

  // Case Axios error 404 string data with html tags
  if (typeof data === 'string' && netInfo.status === 404) {
    netInfo.title = 'Access Denied'
    netInfo.message = 'Not Found'
  }

  return netInfo
}
